import { ReactNode } from 'react';
import { useFormTableErrors } from './TanstackFormTable';
import styled from 'styled-components';
import { colorError } from '@atlas-frontend/design-tokens';

interface ErrorCellProps {
  rowIndex: number;
  columnCode: string;
  children: ReactNode;
}

export const ErrorCell: React.FC<ErrorCellProps> = ({
  rowIndex,
  columnCode,
  children,
}) => {
  const errorInfo = useFormTableErrors();
  const hasError =
    errorInfo?.cellErrors.has(`${rowIndex}:${columnCode}`) || false;

  return <ErrorCellWrapper $hasError={hasError}>{children}</ErrorCellWrapper>;
};

export const ErrorCellWrapper = styled.div<{ $hasError: boolean }>`
  width: 100%;
  height: 100%;
  ${({ $hasError }) =>
    $hasError &&
    `
    position: relative;
    &::after {
      content: '';
      position: absolute;
      left: -8px;
      right: -8px;
      bottom: -4px;
      height: 2px;
      background-color: ${colorError};
    }
  `}
`;
